var _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgTsvFile = function SvgTsvFile(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 115,
    viewBox: "0 0 114 115",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91 103.867H29C27.3431 103.867 26 102.524 26 100.867V14.8667C26 13.2098 27.3431 11.8667 29 11.8667H66.5858L94 39.2809V100.867C94 102.524 92.6569 103.867 91 103.867Z",
    fill: "white",
    stroke: "#E1E1E1",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67 10.8667L95 38.8667H71C68.7909 38.8667 67 37.0758 67 34.8667V10.8667Z",
    fill: "#E1E1E1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5489_226180)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "box",
    x: 15,
    y: 57.8667,
    width: 63,
    height: 33,
    rx: 4,
    fill: "currentColor",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4979 70.7587V68.7303H40.0547V70.7587H36.4922V80.3667H34.0604V70.7587H30.4979ZM47.9411 72.0769C47.8956 71.6186 47.7005 71.2625 47.3558 71.0087C47.0111 70.755 46.5433 70.6281 45.9524 70.6281C45.5509 70.6281 45.2119 70.6849 44.9354 70.7985C44.6589 70.9084 44.4467 71.0618 44.299 71.2587C44.1551 71.4557 44.0831 71.6792 44.0831 71.9292C44.0755 72.1375 44.1191 72.3194 44.2138 72.4747C44.3123 72.63 44.4467 72.7644 44.6172 72.8781C44.7876 72.9879 44.9846 73.0845 45.2081 73.1678C45.4316 73.2474 45.6702 73.3156 45.924 73.3724L46.9695 73.6224C47.477 73.736 47.9429 73.8875 48.3672 74.0769C48.7914 74.2663 49.1589 74.4993 49.4695 74.7758C49.7801 75.0523 50.0206 75.3781 50.1911 75.7531C50.3653 76.1281 50.4543 76.558 50.4581 77.0428C50.4543 77.755 50.2725 78.3724 49.9126 78.8951C49.5566 79.414 49.0414 79.8175 48.3672 80.1053C47.6967 80.3894 46.888 80.5315 45.9411 80.5315C45.0017 80.5315 44.1835 80.3875 43.4865 80.0997C42.7933 79.8118 42.2517 79.3856 41.8615 78.8212C41.4751 78.2531 41.2725 77.5504 41.2536 76.7133H43.6342C43.6607 77.1034 43.7725 77.4292 43.9695 77.6906C44.1702 77.9481 44.4373 78.1432 44.7706 78.2758C45.1077 78.4046 45.4884 78.469 45.9126 78.469C46.3293 78.469 46.6911 78.4084 46.9979 78.2872C47.3085 78.1659 47.549 77.9974 47.7195 77.7815C47.8899 77.5656 47.9751 77.3175 47.9751 77.0372C47.9751 76.7758 47.8975 76.5561 47.7422 76.3781C47.5907 76.2 47.3672 76.0485 47.0717 75.9235C46.7801 75.7985 46.4221 75.6849 45.9979 75.5826L44.7308 75.2644C43.7498 75.0258 42.9751 74.6527 42.407 74.1451C41.8388 73.6375 41.5566 72.9538 41.5604 72.094C41.5566 71.3894 41.7441 70.7739 42.1229 70.2474C42.5054 69.7209 43.0301 69.3099 43.6967 69.0144C44.3634 68.719 45.121 68.5712 45.9695 68.5712C46.8331 68.5712 47.5869 68.719 48.2308 69.0144C48.8786 69.3099 49.3823 69.7209 49.7422 70.2474C50.102 70.7739 50.2876 71.3837 50.299 72.0769H47.9411ZM54.2152 68.7303L57.0277 77.5712H57.1357L59.9538 68.7303H62.6811L58.6697 80.3667H55.4993L51.4822 68.7303H54.2152Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5489_226180",
    x: 11,
    y: 56.8667,
    width: 71,
    height: 41,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.701961 0 0 0 0 0.737255 0 0 0 0 0.752941 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5489_226180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_5489_226180",
    result: "shape"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTsvFile);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "tsv-file.c74943d7dd9e68ed885321406d544cdb.svg";